import { useDevice } from 'lib/hooks/useDevice';
import { useEffect, useState } from 'react';
import { ContinueCta } from './Continue';

const PaymentCta = () => {
  const [
    isPaymentMethodWrapperInViewport,
    setIsPaymentMethodWrapperInViewport,
  ] = useState(false);

  const bottomActionBarElement = document.getElementById('bottom-action-bar');
  const headerElement = document.getElementById('top-header');

  useEffect(() => {
    const paymentMethodWrapper = document.querySelector(
      '#payment-method-wrapper'
    );

    let rootMarginBottom = 0;
    if (bottomActionBarElement) {
      rootMarginBottom = bottomActionBarElement.offsetHeight;
    }

    // use intersection observer to check if the payment method wrapper is in the viewport
    const observer = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setIsPaymentMethodWrapperInViewport(true);
        } else {
          setIsPaymentMethodWrapperInViewport(false);
        }
      },
      {
        rootMargin: `0px 0px -${rootMarginBottom + 200}px 0px`,
        threshold: 0, // Explicitly setting threshold, can be an array too
      }
    );

    if (paymentMethodWrapper) observer.observe(paymentMethodWrapper);

    return () => {
      if (paymentMethodWrapper) observer.unobserve(paymentMethodWrapper);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { isMobile } = useDevice();
  return isMobile ? (
    <ContinueCta
      submitHandler={() => {
        console.log('continue');
        const paymentMethodWrapper = document.querySelector(
          '#payment-method-wrapper'
        );

        if (paymentMethodWrapper) {
          if (headerElement) {
            const headerHeight = headerElement.offsetHeight;
            const elementTopRelativeToDocument =
              paymentMethodWrapper.getBoundingClientRect().top + window.scrollY;
            const targetScrollToPosition =
              elementTopRelativeToDocument - headerHeight;
            window.scrollTo({
              top: targetScrollToPosition,
              behavior: 'smooth',
            });
          } else {
            // Fallback if headerElement is not found
            paymentMethodWrapper.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'center', // Preserving inline: 'center' for fallback
            });
          }
        }
      }}
      className={`bg-red-600 bg-opacity-20 border-t md:border-none border-opacity-20 border-red-900`}
      isDisabled={false}
      isLoading={false}
      submitButtonText="Continue"
      showLimitedSpots={false}
      showTimer={true}
      hideButton={isPaymentMethodWrapperInViewport}
    />
  ) : null;
};

export { PaymentCta };
